import { useState, useRef, useEffect } from "react";

const useExercisePlanTimer = (planInitiateTime, totalDurationInSeconds) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const intervalRef = useRef(null);

  // ✅ Function to get time difference in seconds
  const getTimeDifference = (startTime) => {
    const start = new Date(startTime);
    const now = new Date();
    const diffMs = now - start;
    return Math.floor(diffMs / 1000);
  };

  // ✅ Function to initialize timeLeft
  const initializeTimer = () => {
    if (!planInitiateTime) return;
    const elapsed = getTimeDifference(planInitiateTime);
    const remaining = Math.max(totalDurationInSeconds - elapsed, 0);
    setTimeLeft(remaining);
  };

  // ✅ Function to start decreasing the timer
  const startCountdown = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1;
        if (newTime <= 0) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return newTime;
      });
    }, 1000);
  };

  // ✅ Function to stop the countdown
  const stopCountdown = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  // Initialize once when component mounts or planInitiateTime changes
  useEffect(() => {
    initializeTimer();
    startCountdown();
    return () => stopCountdown();
  }, [planInitiateTime]);

  return {
    timeLeft,
    setTimeLeft,
    getTimeDifference,
    initializeTimer,
    startCountdown,
    stopCountdown,
  };
};

export default useExercisePlanTimer;
